import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const KEY = 'ms_cookie_consent';

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch (e) {
      setShow(true);
    }
  }, []);

  const choose = (value) => {
    try { localStorage.setItem(KEY, value); } catch (e) { /* ignore */ }
    // value === 'accepted' → analytics may be enabled here once configured
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-4">
      <div className="max-w-4xl mx-auto bg-gray-900 text-white rounded-2xl shadow-2xl p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-sm text-gray-200 flex-1">
          We use essential cookies to run ManuscriptSmith and, with your consent, analytics cookies to improve it.
          See our <Link to="/cookies" className="text-secondary-300 underline hover:text-secondary-200">Cookies Policy</Link>.
        </p>
        <div className="flex gap-3 flex-shrink-0">
          <button
            onClick={() => choose('declined')}
            className="px-4 py-2 text-sm font-medium rounded-lg border border-gray-600 text-gray-200 hover:bg-gray-800 transition-colors"
          >
            Decline
          </button>
          <button
            onClick={() => choose('accepted')}
            className="px-5 py-2 text-sm font-bold rounded-lg bg-gradient-to-r from-primary-500 to-secondary-500 text-white hover:from-primary-600 hover:to-secondary-600 transition-all"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
